import {httpGetProjectNotes, HttpGetProjectNotesResponse} from '@/features/projects/http/projects.http'
import {QUERY_KEYS} from '@/queryClient'
import {ResponseType} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'

interface UseGetProjectNotesOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<UseQueryOptions<HttpGetProjectNotesResponse[]>, 'queryKey' | 'queryFn'>
}

export const useGetProjectNotes = ({urlParams, options}: UseGetProjectNotesOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.PROJECT_NOTES, urlParams.projectId],
        queryFn: () => httpGetProjectNotes({urlParams, params: {responseType: ResponseType.enum.extended}}),
        ...options
    })
